import esports from "../../../assets/sportsicon/esports.svg";
import gyming from "../../../assets/sportsicon/gyming.svg";
import snooker from "../../../assets/sportsicon/snooker.svg";
import bowling from "../../../assets/sportsicon/bowling.svg";
import tableTennis from "../../../assets/sportsicon/table-tennis.svg";
import yoga from "../../../assets/sportsicon/yoga.svg";
import poker from "../../../assets/sportsicon/poker.svg";

import basketball from "../../../assets/sportsicon/basketball.svg";
import football from "../../../assets/sportsicon/football.svg";
import tennis from "../../../assets/sportsicon/tennis.svg";
import golf from "../../../assets/sportsicon/golf.svg";
import cricket from "../../../assets/sportsicon/cricket.svg";
import hockey from "../../../assets/sportsicon/hockey.svg";
import volleyball from "../../../assets/sportsicon/football.svg";
import americanFootball from "../../../assets/sportsicon/american-football.svg";
import badminton from "../../../assets/sportsicon/badminton.svg";
import skating from "../../../assets/sportsicon/skating.svg";
import cross from "../../../assets/sportsicon/cross.svg"
import paddle from "../../../assets/sportsicon/paddle.svg"
import multiSports from "../../../assets/sportsicon/multi-sports.svg";

const sportIcons = {
    "E-sports": esports,
    "Gyming": gyming,
    "Snooker": snooker,
    "Bowling": bowling,
    "Table Tennis": tableTennis,
    "Yoga": yoga,
    "Poker": poker,
    "Basketball": basketball,
    "Football": football,
    "Tennis": tennis,
    "Golf": golf,
    "Cricket": cricket,
    "Hockey": hockey,
    "Volleyball": volleyball,
    "American Football": americanFootball,
    "Badminton": badminton,
    "Skating": skating,
    "Paddle": paddle,
    "Cross": cross,
    "Multi-Sports": multiSports

};

export default sportIcons;
